export default __webpack_public_path__ + "static/media/halas12.05848732.jpg";